import AdTable from './AdTable';
export default AdTable;
